export const INITIAL_STATE = {
    // do not reacting to state update, only join and leave
    people: [],
    // type = patient
    patients: [],
    // type = doctor
    doctors: [],
    // UUIDs of force removed people
    forceRemovedUUIDs: [],
};
